import type { PermissionRequirement } from "~/hooks/usePermission"

/**
 * Who may change a plan's strategic inputs (comparable collection, assortment strategy answers,
 * baseline adjustments): admin-only, as they drive the whole plan. Gate on this, not "edit".
 */
export const STRATEGY_REQUIRES = "administer" satisfies PermissionRequirement
